import {
  Component,
  OnInit
} from '@angular/core';

import {
  AuthService
} from './AuthService';

import {
  environment
} from '../../environments/environment';


@Component({
  selector: 'app-signin-callback',
  template: `<div></div>`
})
export class SigninRedirectCallbackComponent
  implements OnInit {

  private callbackHandled = false;

  constructor(
    private authService: AuthService
  ) {}


  async ngOnInit(): Promise<void> {

    if (this.callbackHandled) {
      return;
    }

    this.callbackHandled = true;

    try {

      /*
       * This waits for:
       *
       * - Keycloak callback processing
       * - OIDC user storage
       * - userType
       * - /userprofile
       * - roles
       * - timezone
       */
      await this.authService.completeLogin();


      /*
       * IMPORTANT
       *
       * Do a fresh application bootstrap after
       * completing the OIDC callback.
       *
       * This is equivalent to the manual refresh
       * that is currently fixing the application.
       */
      window.location.replace(
        environment.clientRoot
      );

    } catch (error) {

    console.error(
        'Unable to complete login:',
        error
    );

    try {
        await this.authService
            .userManager
            .removeUser();

        window.location.replace(
            environment.clientRoot
        );

    } catch (recoveryError) {

        console.error(
            'Authentication recovery failed:',
            recoveryError
        );

        window.location.replace(
            environment.clientRoot
        );
    }
    }
  }
}